import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
} from './changelog-versions.action';

import {
    fetchRecordsSuccess as fetchRecordsSuccessAccess,
} from '../Access/access.action';

import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';

@Injectable()
export class ChangelogVersionsRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap(() => {
                const url = 'contributie-changelog-versions';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        const listData = response.data;
                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
    ) { }

}